// src/data/defaultContractTemplate.js

export const DEFAULT_CONTRACT_NAME = 'CONTRATO DE PRESTAÇÃO DE SERVIÇOS DE TECNOLOGIA DA INFORMAÇÃO (TI)';

export const DEFAULT_CONTRACT_CLAUSES = [
    // GRUPO 1: DO OBJETO DO CONTRATO
    {
        id: 'cl-1',
        group: 'DO OBJETO DO CONTRATO',
        title: 'Cláusula 1ª',
        text: 'O presente contrato tem como OBJETO, a prestação de serviços de consultoria, manutenção nos servidores/rede e assessoria na manutenção do banco de dados, suporte técnico presencial ou remoto. Será prestado também gestão na área de TI, onde será feito o levantamento para solucionar problemas conceituais da tecnologia adotada, realizado pela CONTRATADA à CONTRATANTE, nos computadores, servidores e serviços de rede de informática.'
    },

    // GRUPO 2: DAS OBRIGAÇÕES DA CONTRATADA
    {
        id: 'cl-2',
        group: 'DAS OBRIGAÇÕES DA CONTRATADA',
        title: 'Cláusula 2ª',
        text: 'A fim de que possa realizar os serviços propostos, a CONTRATADA disponibilizará à CONTRATANTE uma equipe de funcionários especialistas na área sempre que for solicitado na modalidade de suporte nos termos especificados a cláusula 1ª.'
    },
    {
        id: 'cl-3',
        group: 'DAS OBRIGAÇÕES DA CONTRATADA',
        title: 'Cláusula 3ª',
        text: 'A CONTRATADA compromete-se a envidar todos os esforços técnicos e disponibilizar profissionais qualificados para a execução das tarefas e suporte técnico acordados.'
    },
    {
        id: 'cl-4',
        group: 'DAS OBRIGAÇÕES DA CONTRATADA',
        title: 'Cláusula 4ª',
        text: 'Identificar e corrigir falhas de funcionamento em equipamentos de informática pertencentes à CONTRATANTE, nos termos deste contrato.'
    },
    {
        id: 'cl-5',
        group: 'DAS OBRIGAÇÕES DA CONTRATADA',
        title: 'Cláusula 5ª',
        text: 'Prestar suporte remoto através de ferramentas seguras e suporte presencial mediante agendamento ou emergência.'
    },
    {
        id: 'cl-6',
        group: 'DAS OBRIGAÇÕES DA CONTRATADA',
        title: 'Cláusula 6ª',
        text: 'Tratar com confidencialidade e zelo todos os dados corporativos a que tiver acesso durante a prestação dos serviços.'
    },
    {
        id: 'cl-7',
        group: 'DAS OBRIGAÇÕES DA CONTRATADA',
        title: 'Cláusula 7ª',
        text: 'Fornecer orientações preventivas e melhores práticas de segurança da informação.'
    },
    {
        id: 'cl-8',
        group: 'DAS OBRIGAÇÕES DA CONTRATADA',
        title: 'Cláusula 8ª',
        text: 'O atendimento será realizado de segunda a sexta-feira, das 08h00 às 18h00, exceto feriados nacionais e municipais da sede da CONTRATADA.\n\nParágrafo Primeiro: Atendimentos emergenciais ou fora do horário padrão poderão ser acordados previamente e faturados à parte.'
    },

    // GRUPO 3: DAS OBRIGAÇÕES DA CONTRATANTE
    {
        id: 'cl-9',
        group: 'DAS OBRIGAÇÕES DA CONTRATANTE',
        title: 'Cláusula 9ª',
        text: 'Efetuar os pagamentos nas datas acordadas conforme estipulado neste instrumento.'
    },
    {
        id: 'cl-10',
        group: 'DAS OBRIGAÇÕES DA CONTRATANTE',
        title: 'Cláusula 10ª',
        text: 'Fornecer acessos, senhas e autorizações necessárias para a execução dos serviços contratados.'
    },
    {
        id: 'cl-10-1',
        group: 'DAS OBRIGAÇÕES DA CONTRATANTE',
        title: 'Cláusula 10.1ª',
        text: 'Não permitir que terceiros não autorizados realizem alterações técnicas nas máquinas cobertas pelo contrato sem prévia anuência da CONTRATADA.'
    },

    // GRUPO 4: DA QUALIDADE, SIGILO E LGPD
    {
        id: 'cl-11',
        group: 'DA QUALIDADE, SIGILO E LGPD',
        title: 'Cláusula 11ª',
        text: 'A CONTRATADA compromete-se a envidar todos os esforços técnicos para prestar serviços com excelência e manter relatórios periódicos de atividades.'
    },
    {
        id: 'cl-11-2-1',
        group: 'DA QUALIDADE, SIGILO E LGPD',
        title: 'Cláusula 11.1ª',
        text: 'A CONTRATADA compromete-se a manter sigilo absoluto sobre informações, dados e rotinas de negócios da CONTRATANTE.'
    },
    {
        id: 'cl-11-2-2',
        group: 'DA QUALIDADE, SIGILO E LGPD',
        title: 'Cláusula 11.2ª',
        text: 'As partes comprometem-se mutuamente a cumprir as disposições da Lei Geral de Proteção de Dados (Lei nº 13.709/2018 - LGPD).'
    },
    {
        id: 'cl-11-2-3',
        group: 'DA QUALIDADE, SIGILO E LGPD',
        title: 'Cláusula 11.3ª',
        text: 'A CONTRATADA orientará a implementação e rotinas de salvaguarda de cópias de segurança (backup).'
    },
    {
        id: 'cl-11-2-4',
        group: 'DA QUALIDADE, SIGILO E LGPD',
        title: 'Cláusula 11.4ª',
        text: 'A CONTRATANTE é a única e exclusiva responsável pelo correto licenciamento de softwares instalados em seus equipamentos.'
    },

    // GRUPO 5: DO ESCOPO E VALORES
    {
        id: 'cl-11-2-5',
        group: 'DO ESCOPO E VALORES',
        title: 'Cláusula 12ª',
        text: 'O presente contrato cobre inicialmente o total de {{QTD_MAQUINAS}} computadores/estações de trabalho devidamente cadastradas.'
    },
    {
        id: 'cl-11-2-6',
        group: 'DO ESCOPO E VALORES',
        title: 'Cláusula 13ª',
        text: 'Pela prestação dos serviços contratados, a CONTRATANTE pagará à CONTRATADA o valor mensal fixo de R$ {{VALOR_MENSAL}}, com vencimento no dia acordado de cada mês.'
    },
    {
        id: 'cl-11-2-7',
        group: 'DO ESCOPO E VALORES',
        title: 'Cláusula 14ª',
        text: 'O pagamento será realizado mediante boleto bancário ou transferência PIX emitidos pela CONTRATADA acompanhados da respectiva Nota Fiscal de Prestação de Serviços.'
    },

    // GRUPO 6: DA VIGÊNCIA E RESCISÃO
    {
        id: 'cl-12',
        group: 'DA VIGÊNCIA E RESCISÃO',
        title: 'Cláusula 15ª',
        text: 'O atraso no pagamento sujeitará a CONTRATANTE a multa moratória de 2% (dois por cento) sobre o valor da parcela vencida, acrescida de juros de 1% (um por cento) ao mês pro rata die e correção monetária.'
    },
    {
        id: 'cl-13',
        group: 'DA VIGÊNCIA E RESCISÃO',
        title: 'Cláusula 16ª',
        text: 'O atraso superior a 30 (trinta) dias poderá acarretar a suspensão dos serviços técnicos após notificação formal.'
    },
    {
        id: 'cl-14',
        group: 'DA VIGÊNCIA E RESCISÃO',
        title: 'Cláusula 17ª',
        text: 'O presente contrato vigorará pelo prazo de 12 (doze) meses contados da data de sua assinatura, sendo renovado automaticamente por iguais períodos caso não haja manifestação contrária por escrito.'
    },
    {
        id: 'cl-15-rescisao',
        group: 'DA VIGÊNCIA E RESCISÃO',
        title: 'Cláusula 18ª',
        text: 'Qualquer das partes poderá rescindir o presente contrato mediante aviso prévio por escrito com antecedência mínima de 30 (trinta) dias, sem incidência de multa rescisória, desde que quitados os valores pendentes até o término efetivo.'
    },

    // GRUPO 7: DOS SERVIÇOS INCLUSOS E NÃO INCLUSOS
    {
        id: 'cl-15-servicos',
        group: 'DOS SERVIÇOS INCLUSOS E NÃO INCLUSOS',
        title: 'Cláusula 19ª',
        text: 'Estão inclusos: Suporte remoto ilimitado em horário comercial para diagnóstico e solução de problemas operacionais de sistemas e manutenção preventiva periódica.'
    },
    {
        id: 'cl-16',
        group: 'DOS SERVIÇOS INCLUSOS E NÃO INCLUSOS',
        title: 'Cláusula 20ª',
        text: 'Não estão inclusos: Custo, fornecimento ou reposição de peças de hardware, componentes eletrônicos, obras físicas de infraestrutura elétrica e suporte a softwares sem documentação do fabricante.'
    },

    // GRUPO 8: DAS DISPOSIÇÕES GERAIS E DO FORO
    {
        id: 'cl-19',
        group: 'DAS DISPOSIÇÕES GERAIS E DO FORO',
        title: 'Cláusula 21ª',
        text: 'A eventual tolerância de qualquer das partes quanto a qualquer infração das cláusulas deste contrato não constituirá renúncia a direitos nem novação contratual.'
    },
    {
        id: 'cl-22',
        group: 'DAS DISPOSIÇÕES GERAIS E DO FORO',
        title: 'Cláusula 22ª',
        text: 'Para dirimir quaisquer controvérsias oriundas do presente contrato, as partes elegem expressamente o Foro da Comarca de Indaiatuba, Estado de São Paulo, com renúncia expressa a qualquer outro, por mais privilegiado que seja.'
    }
];
